import { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { FrontierProvider } from 'react-frontier';
import RouterComponent from './Router';
import { UserProvider, useUser } from './hooks';
import API from './API';

import './style/site.scss';

var router = RouterComponent();

var Root =()=>{
	var { login } = useUser();
	var is_auth = window.location.pathname === '/auth';

	useEffect(()=>{
		if(!API.getToken() && !is_auth) window.location.href = API.getLoginUrl();

		var onLogout =()=>{ window.location.href = API.getLoginUrl(); };
		window.addEventListener('team_hr_user_logout', onLogout);

		return () => window.removeEventListener('team_hr_user_logout', onLogout);
	}, [login]);

	return <FrontierProvider locale="es">
		<RouterProvider router={router} future={{ v7_startTransition: true }} />
	</FrontierProvider>;
};

var root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
	<UserProvider>
		<Root />
	</UserProvider>
);
